import {useEffect, useState} from 'react';
import {useCookies} from "react-cookie";

function usePsps() {
    const [psps, setPsps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    const fetchPaymentProviders = async () => {
        const response = await fetch(`${apiRoot}/backoffice/payment-service-providers?page=0&size=100`, {headers: apiHeaders});
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    };

    const getPsps = async () => {
        try {
            setLoading(true);
            const data = await fetchPaymentProviders();

            let allData = [...data.content];

            for (let i = 0; i < allData.length; i++) {
                const response = await fetch(apiRoot + '/backoffice/payment-service-providers/' + allData[i].id + '/payment-methods?page=0&size=100', {headers: apiHeaders});
                const paymentData = await response.json();
                const paymentContent = paymentData.content;
                let methods = '';
                for (let i = 0; i < paymentContent.length; i++) {
                    if (i > 0) {
                        methods += ', ';
                    }
                    methods += paymentContent[i].name;
                }
                allData[i].payments = methods;
            }


            setPsps(allData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getPsps();
    }, []);

    return {psps, setPsps, getPsps, loading, setLoading, error, setError};
}

export default usePsps;
